<div *ngIf="timeRemaining$ | async as t" class="gb-timer" [ngClass]="timerClass">
  <div [class.blinking]="animateOnTimerEnding && (isTimerEnding$ | async)">
    <span *ngIf="timerEndMessage && (hasTimerEnded$ | async); else timer" [translate]="timerEndMessage"> </span>

    <ng-template #timer>
      <div class="timer-container">
        <div class="timer-title" *ngIf="title">
          <span>{{ title | translate }}</span>
        </div>
        <div class="flex-row flex-justify-space-around flex-align-start">
          <div *ngFor="let item of t" class="figure-container">
            <span class="figure">
              {{ item.figure | number: digitsInfo }}
            </span>
            <small class="figure-label">
              {{ item.label | translate }}
            </small>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
